interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
}

const SUGGESTIONS = [
  "What's the status of my latest order?",
  'Show me my order history',
  'Where is my shipment?',
  'What orders do I have pending?',
];

export function SuggestedQuestions({ onSelect }: SuggestedQuestionsProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
      }}
    >
      <p
        style={{
          fontSize: '0.875rem',
          color: '#666',
          marginBottom: '0.5rem',
        }}
      >
        Suggested questions:
      </p>
      {SUGGESTIONS.map((question, index) => (
        <button
          key={index}
          onClick={() => onSelect(question)}
          style={{
            padding: '0.75rem 1rem',
            backgroundColor: '#f0f4f8',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            cursor: 'pointer',
            textAlign: 'left',
            fontSize: '0.875rem',
            color: '#334155',
            transition: 'background-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#e2e8f0';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f0f4f8';
          }}
        >
          {question}
        </button>
      ))}
    </div>
  );
}
